// 📁 components/common/RenderTags.jsx
import React from 'react';
import SkillBadge from '../../../common/skillBadge';

const RenderTags = ({ values = [], fallback = 'Nil', className = '' }) => {
  const items = Array.isArray(values) ? values : values ? [values] : [];

  const filtered = items.filter(Boolean);
  if (filtered.length === 0) {
    return <span className="text-gray-333 text-xs">{fallback}</span>;
  }

  return (
    <div className={`flex flex-wrap gap-2 mt-1 ${className}`}>
      {filtered.map((item, idx) => {
        let label = '';
        if (typeof item === 'object' && item !== null) {
          label = item.language || item.name || item.libelle || item.label || item.value || '';
          if (!label) {
            label = JSON.stringify(item);
          }
        } else {
          label = String(item);
        }
        return (
          <SkillBadge key={`${label}_${idx}`}>
            {label}</SkillBadge>
        );
      })}
    </div>
  );
};

export default RenderTags;
